export class MiniPlayer {
  #isApplied = false;
  #container = null;
  #styleElement =
    document.getElementById('mggp-mini-player-style') ??
    (() => {
      const el = document.createElement('style');
      el.id = 'mggp-mini-player-style';
      return document.head.appendChild(el);
    })();

  constructor(container) {
    this.#container = container;
  }

  apply = (parameters) => {
    if (!parameters) {
      return;
    }
    const videoElement = this.#container.querySelector('video');
    if (!videoElement) {
      return;
    }

    const containerId = this.#container.id;
    const transform = `translate(${parameters.left}px, ${parameters.top}px)`;

    this.#styleElement.innerHTML = `.player #${containerId} video {
    transform-origin: top left;
    transform: none;
    transition: width, height, transform 0.1s ease-in-out;
  }
  .player.position-fixed #${containerId} video {
    transform: none;
    transition: none;
    transform-origin: unset;
  }
  .player:not(.position-fixed) #${containerId} video.mini-player {
    transform: ${transform};
    max-width: ${parameters.width}px;
    max-height: ${parameters.height}px;
    z-index: var(--interactive-layer-zindex, 10);
  }
  `;

    videoElement.classList.add('mini-player');
    this.#isApplied = true;
  };

  restore = () => {
    if (this.#isApplied) {
      const videoElement = this.#container?.querySelector('video');

      videoElement?.classList.add('mini-player');
    }
  };

  suspend = () => {
    if (this.#isApplied) {
      this.#revert();
    }
  };

  dispose = () => {
    this.#revert();
    this.#isApplied = false;
  };

  #revert = () => {
    const videoElement = this.#container.querySelector('video');

    videoElement?.classList.remove('mini-player');
  };
}
